import { FormControlLabel, Paper, Stack, Switch, Typography } from '@mui/material';
import { Study } from 'interfaces/study';
import React from 'react';

interface PeakDetectionSettingsProps {
  updatedSettings?: Study['settings'];
  setUpdatedSettings: React.Dispatch<React.SetStateAction<Study['settings']>>;
}

export const PeakDetectionSettings = ({ updatedSettings, setUpdatedSettings }: PeakDetectionSettingsProps) => (
  <Paper component="section" variant="outlined" sx={{ p: { xs: 2, md: 2.5 } }}>
    <Stack spacing={1}>
      <Typography variant="subtitle2">Peak detection</Typography>
      <FormControlLabel
        control={
          <Switch
            checked={updatedSettings?.mIF?.peakDetectionUseRawDog ?? false}
            inputProps={{ 'aria-label': 'Use peak detection v2 by default' }}
            onChange={(_, checked) =>
              setUpdatedSettings((currentSettings) => ({
                ...currentSettings,
                mIF: {
                  ...currentSettings?.mIF,
                  peakDetectionUseRawDog: checked,
                },
              }))
            }
          />
        }
        label="Use peak detection v2 by default"
      />
      <Typography variant="caption" color="text.secondary">
        New peak detection runs start with raw-channel Difference of Gaussians detection enabled. Operators can still
        change the version in Advanced settings before running.
      </Typography>
    </Stack>
  </Paper>
);
